
import React from 'react';
import Image  from 'react-bootstrap/Image';

import gifLoading from "../assets/gifs/Lightcast_LoadingGif_Sailor_Red.gif";

const Preloader = (props) => {

  const { show } = props;

  return (
    <div className={`preloader bg-soft flex-column justify-content-center align-items-center ${show ? "" : "show"}`}>
      { show && <Image className="loading-screen__gif" src={gifLoading} />}
    </div>
  );
};

export default Preloader;